import { useState, useEffect } from "react";
import { Input } from "reactstrap";
import Select from "react-select";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import { StatusChip } from "../common/StatusChip";

export const UserDeliverySection = ({
  setSelectedUser,
  currency,
  setCurrency,
  createdAt,
  setCreatedAt,
}) => {
  const { getData } = useDataFetch();
  const [searchTerm, setSearchTerm] = useState("");
  const [finalSearch, setFinalSearch] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setFinalSearch(searchTerm.trim());
    }, 600);
    return () => clearTimeout(timeout);
  }, [searchTerm]);

  const { data: usersData, isPending: loadingUsers } = getData(
    ["users", finalSearch],
    "/users/all",
    { enabled: finalSearch.length >= 3 },
    { search: finalSearch }
  );

  const users = usersData?.data?.users || [];

  const mappedOptions = users.map((user) => ({
    value: user.id,
    label: user.document
      ? `${user.multyhealth_code} - ${user.document} - ${user.name}`
      : `${user.multyhealth_code} - ${user.name}`,
    user,
  }));

  const options = finalSearch.length >= 3 ? mappedOptions : selectedOption ? [selectedOption] : [];

  const handleChange = (option) => {
    setSelectedOption(option || null);
    setSelectedUser(option ? option : null);
    setSearchTerm("");
    setFinalSearch("");
  };

  const isNetworkActive = selectedOption?.user?.network?.loyalty_status || selectedOption?.user?.network?.influencer_bonus_status;

  return (
    <div className="ui-card">
      <h3 style={{ margin: "0 0 16px", fontSize: 16, fontWeight: 700 }}>1 · Cliente</h3>

      {!selectedOption ? (
        <Select
          value={selectedOption}
          options={options}
          getOptionValue={(opt) => opt.value}
          getOptionLabel={(opt) => opt.label}
          onChange={handleChange}
          onInputChange={(val, { action }) => {
            if (action === "input-change") setSearchTerm(val);
          }}
          inputValue={searchTerm}
          placeholder="Buscar por código, cédula o nombre"
          isClearable
          isLoading={finalSearch.length >= 3 && loadingUsers}
          noOptionsMessage={() =>
            searchTerm.length < 3 ? "Escribe al menos 3 caracteres" : "No se encontraron usuarios"
          }
        />
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 15,
            background: "#FAFAFF",
            border: "1.5px solid #4B36F0",
            borderRadius: 11,
            padding: "14px 16px",
            flexWrap: "wrap",
          }}
        >
          <div style={{ width: 44, height: 44, borderRadius: "50%", background: "#EDEFF6", display: "flex", alignItems: "center", justifyContent: "center", color: "#9AA1BC", flexShrink: 0 }}>
            <i className="ri-user-line" style={{ fontSize: 20 }} />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 14.5, fontWeight: 700 }}>{selectedOption.user.name}</div>
            <div style={{ color: "#5A6187", fontSize: 12, marginTop: 2 }}>
              <span style={{ fontFamily: "'JetBrains Mono',monospace" }}>{selectedOption.user.multyhealth_code}</span>
              {selectedOption.user.email ? ` · ${selectedOption.user.email}` : ""}
              {selectedOption.user.document ? ` · CC ${selectedOption.user.document}` : ""}
            </div>
          </div>
          {isNetworkActive && <StatusChip tone="success" icon="ri-checkbox-circle-line">Red activa</StatusChip>}
          <button
            type="button"
            onClick={() => handleChange(null)}
            style={{ background: "none", border: "none", color: "#4B36F0", fontSize: 12.5, fontWeight: 600, cursor: "pointer" }}
          >
            Cambiar
          </button>
        </div>
      )}

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginTop: 14 }}>
        <div>
          <label style={{ display: "block", fontSize: 12.5, fontWeight: 600, marginBottom: 6 }}>Moneda</label>
          <Input type="select" value={currency} onChange={(e) => setCurrency(e.target.value)}>
            <option value="COP">COP - Peso colombiano</option>
            <option value="USDT">USDT - Tether</option>
            <option value="EUR">EUR - Euro</option>
          </Input>
        </div>
        <div>
          <label style={{ display: "block", fontSize: 12.5, fontWeight: 600, marginBottom: 6 }}>Fecha de creación</label>
          <Input type="datetime-local" value={createdAt} onChange={(e) => setCreatedAt(e.target.value)} />
        </div>
      </div>
    </div>
  );
};
